<template>
    <div id="location-share">
        <div class="btn" @click="showMap = true">
            <md-icon>my_location</md-icon>
        </div>
        <Modal2 v-if="showMap" :show-footer="false" @cancel="showMap = false">
            <l-map ref="map" @ready="ready" :center="center" :zoom="zoom" class="map" @click="mapClick">
                <l-tile-layer :url="url" />
                <l-marker draggable :icon="icons.default" :lat-lng.sync="center" />
            </l-map>
            <div class="btn mt-3 pointer" @click="getCurrentLocation" :class="{ disabled: !locationEnabled }">
                <md-icon>my_location</md-icon>
                <span>{{ $t("message.useMyLocation") }}</span>
                <div class="text-danger" v-if="!locationEnabled">({{ $t("message.locationPermsNeeded") }})</div>
            </div>
            <b-button class="mt-3 btn-success d-block" @click="sendLocation">{{ $t("message.send") }}</b-button>
        </Modal2>
    </div>
</template>

<script>
import { mapState } from "vuex";
import L from "leaflet";
import { sendSocketMessage } from "../utils/socketStream";
import log2 from "../utils/log2";
import _ from "lodash";
import Modal2 from "../components/common/Modal2.vue";

const log = log2("LocationShare.vue");

export default {
    name: "LocationShare",
    components: {
        Modal2,
    },
    data() {
        return {
            showMap: false,
            url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
            zoom: 15,
            center: { lat: 41.02964338716641, lng: 29.00115966796875 },
            icons: {
                default: L.icon({
                    iconUrl: "https://img.icons8.com/ios-glyphs/30/undefined/marker--v1.png",
                    iconSize: [34, 34],
                    iconAnchor: [17, 17],
                }),
            },
            locationEnabled: true,
        };
    },
    computed: {
        ...mapState({
            visitorId: (state) => state.chat.activeConversation.visitor._id,
            conversationId: (state) => state.chat.activeConversation._id,
            activeConversation: (state) => state.chat.activeConversation,
            siteId: (state) => state.site.site._id,
            user: (state) => state.auth.user,
            userGeoLocation: (state) => _.get(state.auth.user, "lastGeoLocation.ll", null),
        }),
    },
    methods: {
        log,
        ready() {
            log(this.$refs.map);
            if (!!this.$refs.map) {
                setTimeout(() => {
                    this.$refs.map.mapObject["invalidateSize"]();
                }, 300);
            }
        },
        userLocation({ coords }) {
            log(coords);
            this.center = { lat: coords.latitude, lng: coords.longitude };
        },
        mapClick({ latlng, ...rest }) {
            log(latlng, rest);
            this.center = { lat: latlng.lat, lng: latlng.lng };
        },
        sendLocation() {
            log("sendLocation");
            this.showMap = false;
            sendSocketMessage("user location message", {
                siteId: this.siteId,
                userId: this.user._id,
                username: this.user.name,
                conversationId: this.conversationId,
                location: this.center,
                whatsappNumber: _.get(this.activeConversation, "whatsappNumber"),
                telegramUserId: _.get(this.activeConversation, "telegramUserId"),
                channelId: _.get(this.activeConversation, "channel"),
            });
        },
        getCurrentLocation() {
            if (!!navigator.geolocation && !!navigator.geolocation.getCurrentPosition)
                navigator.geolocation.getCurrentPosition(this.userLocation.bind(this), () => {
                    this.locationEnabled = false;
                });
        },
    },
    async mounted() {
        log("mounted");
        if (!!navigator.permissions) {
            const permission = await navigator.permissions.query({ name: "geolocation" });
            this.locationEnabled = !(permission.state === "denied");
        }
        if (!!this.userGeoLocation) this.center = { lat: this.userGeoLocation[0], lng: this.userGeoLocation[1] };
    },
    watch: {
        showMap(val) {
            if (val) this.getCurrentLocation();
        },
        userGeoLocation() {
            if (!!this.userGeoLocation) this.center = { lat: this.userGeoLocation[0], lng: this.userGeoLocation[1] };
        },
    },
};
</script>

<style lang="scss" scoped>
#location-share {
    .btn {
        cursor: pointer;
        position: absolute;
        z-index: 1;
        right: 100px;
        top: 0;
    }
}

.map {
    height: 300px;
    border-radius: 8px;
    overflow: hidden;
}
</style>
